import React from 'react';
import { UserLayout } from '../../components/Layout/UserLayout';
import { LayoutDashboard, SproutIcon, DollarSign, Users, CloudRain, LineChart, ArrowUpRight, ArrowDownRight, CalendarIcon, AlertCircle, PlusCircle, BarChart3 } from 'lucide-react';
export const FarmerDashboardPage = () => {
  // Sample data for farmer dashboard
  const farmStats = [{
    title: 'Active Projects',
    value: '3',
    change: '+1',
    isPositive: true,
    icon: <SproutIcon size={20} className="text-green-600" data-id="element-715" />
  }, {
    title: 'Total Funding',
    value: 'RM 840,000',
    change: '+12%',
    isPositive: true,
    icon: <DollarSign size={20} className="text-amber-600" data-id="element-716" />
  }, {
    title: 'Investors',
    value: '12',
    change: '+3',
    isPositive: true,
    icon: <Users size={20} className="text-blue-600" data-id="element-717" />
  }, {
    title: 'Yield Forecast',
    value: '92%',
    change: '-2%',
    isPositive: false,
    icon: <CloudRain size={20} className="text-purple-600" data-id="element-718" />
  }];
  const activeProjects = [{
    id: 1,
    name: 'Sustainable Rice Farming Initiative',
    location: 'MADA Region, Kedah',
    fundingGoal: 'RM 320,000',
    funded: 'RM 320,000',
    progress: 70,
    investors: 5,
    nextMilestone: 'Harvest',
    dueDate: '2024-03-15'
  }, {
    id: 2,
    name: 'Vertical Farming Technology',
    location: 'Cyberjaya, Selangor',
    fundingGoal: 'RM 550,000',
    funded: 'RM 550,000',
    progress: 50,
    investors: 4,
    nextMilestone: 'Growing System Operational',
    dueDate: '2024-06-01'
  }, {
    id: 3,
    name: 'Aquaculture Farming System',
    location: 'Kuala Selangor, Selangor',
    fundingGoal: 'RM 420,000',
    funded: 'RM 210,000',
    progress: 45,
    investors: 3,
    nextMilestone: 'First Stocking',
    dueDate: '2024-01-15'
  }];
  const upcomingTasks = [{
    id: 1,
    title: 'Submit Progress Report',
    project: 'Sustainable Rice Farming',
    dueDate: '2023-12-10',
    priority: 'High'
  }, {
    id: 2,
    title: 'Schedule Investor Visit',
    project: 'Vertical Farming Technology',
    dueDate: '2023-12-15',
    priority: 'Medium'
  }, {
    id: 3,
    title: 'Update Milestone Photos',
    project: 'Aquaculture System',
    dueDate: '2023-12-20',
    priority: 'Medium'
  }, {
    id: 4,
    title: 'Review Funding Proposal',
    project: 'New Organic Project',
    dueDate: '2023-12-25',
    priority: 'High'
  }];
  return <UserLayout requiredUserType="farmer" data-id="element-719">
      <div className="mb-6" data-id="element-720">
        <h1 className="text-2xl font-bold text-soil-brown flex items-center" data-id="element-721">
          <LayoutDashboard size={24} className="mr-2" data-id="element-722" />
          Farmer Dashboard
        </h1>
        <p className="text-gray-600" data-id="element-723">
          Welcome back to your farm management dashboard
        </p>
      </div>
      {/* Farm Stats */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6" data-id="element-724">
        {farmStats.map((stat, index) => <div key={index} className="bg-white rounded-lg shadow-sm p-4 border-l-4 border-leaf-green" data-id="element-725">
            <div className="flex justify-between items-start" data-id="element-726">
              <div data-id="element-727">
                <p className="text-sm text-gray-500" data-id="element-728">{stat.title}</p>
                <h3 className="text-2xl font-bold mt-1" data-id="element-729">{stat.value}</h3>
                <div className={`flex items-center mt-1 text-sm ${stat.isPositive ? 'text-green-600' : 'text-red-600'}`} data-id="element-730">
                  {stat.isPositive ? <ArrowUpRight size={14} className="mr-1" data-id="element-731" /> : <ArrowDownRight size={14} className="mr-1" data-id="element-732" />}
                  <span data-id="element-733">{stat.change} from last month</span>
                </div>
              </div>
              <div className="p-2 bg-gray-100 rounded-full" data-id="element-734">{stat.icon}</div>
            </div>
          </div>)}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-735">
        {/* Active Projects */}
        <div className="lg:col-span-2" data-id="element-736">
          <div className="bg-white rounded-lg shadow-sm p-4" data-id="element-737">
            <div className="flex justify-between items-center mb-4" data-id="element-738">
              <h2 className="text-lg font-semibold flex items-center" data-id="element-739">
                <SproutIcon size={18} className="mr-2 text-leaf-green" data-id="element-740" />
                My Active Projects
              </h2>
              <button className="text-sm flex items-center text-leaf-green hover:underline" data-id="element-741">
                <PlusCircle size={14} className="mr-1" data-id="element-742" />
                New Project
              </button>
            </div>
            <div className="space-y-4" data-id="element-743">
              {activeProjects.map(project => <div key={project.id} className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow" data-id="element-744">
                  <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start" data-id="element-745">
                    <div data-id="element-746">
                      <h3 className="font-medium" data-id="element-747">{project.name}</h3>
                      <p className="text-sm text-gray-600" data-id="element-748">
                        {project.location}
                      </p>
                    </div>
                    <div className="mt-2 sm:mt-0 text-right" data-id="element-749">
                      <p className="text-sm" data-id="element-750">
                        <span className="text-gray-600" data-id="element-751">Funding: </span>
                        <span className="font-medium" data-id="element-752">{project.funded}</span>
                        <span className="text-gray-400" data-id="element-753">
                          {' '}
                          / {project.fundingGoal}
                        </span>
                      </p>
                      <p className="text-sm" data-id="element-754">
                        <span className="text-gray-600" data-id="element-755">Investors: </span>
                        <span className="font-medium" data-id="element-756">{project.investors}</span>
                      </p>
                    </div>
                  </div>
                  <div className="mt-3" data-id="element-757">
                    <div className="flex justify-between text-sm mb-1" data-id="element-758">
                      <span data-id="element-759">Progress</span>
                      <span data-id="element-760">{project.progress}%</span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-761">
                      <div className="bg-leaf-green h-2 rounded-full" style={{
                    width: `${project.progress}%`
                  }} data-id="element-762"></div>
                    </div>
                  </div>
                  <div className="mt-3 flex justify-between items-center" data-id="element-763">
                    <div className="text-sm" data-id="element-764">
                      <span className="text-gray-600" data-id="element-765">Next Milestone: </span>
                      <span className="font-medium" data-id="element-766">
                        {project.nextMilestone}
                      </span>
                      <span className="text-gray-600 ml-1" data-id="element-767">
                        by{' '}
                        {new Date(project.dueDate).toLocaleDateString('en-MY', {
                      day: 'numeric',
                      month: 'short'
                    })}
                      </span>
                    </div>
                    <button className="text-sm text-leaf-green hover:underline" data-id="element-768">
                      Update
                    </button>
                  </div>
                </div>)}
            </div>
          </div>
          {/* Yield & Performance */}
          <div className="bg-white rounded-lg shadow-sm p-4 mt-6" data-id="element-769">
            <div className="flex justify-between items-center mb-4" data-id="element-770">
              <h2 className="text-lg font-semibold flex items-center" data-id="element-771">
                <BarChart3 size={18} className="mr-2 text-purple-600" data-id="element-772" />
                Yield & Performance
              </h2>
              <div className="flex space-x-2" data-id="element-773">
                <button className="text-xs px-2 py-1 bg-gray-100 rounded hover:bg-gray-200" data-id="element-774">
                  Weekly
                </button>
                <button className="text-xs px-2 py-1 bg-leaf-green text-white rounded" data-id="element-775">
                  Monthly
                </button>
                <button className="text-xs px-2 py-1 bg-gray-100 rounded hover:bg-gray-200" data-id="element-776">
                  Yearly
                </button>
              </div>
            </div>
            <div className="space-y-4" data-id="element-777">
              <div className="h-60 bg-gray-100 rounded-lg flex items-center justify-center" data-id="element-778">
                <p className="text-gray-500" data-id="element-779">
                  Yield performance chart placeholder
                </p>
              </div>
              <div className="grid grid-cols-3 gap-3" data-id="element-780">
                <div className="bg-gray-50 p-3 rounded-lg" data-id="element-781">
                  <p className="text-xs text-gray-500" data-id="element-782">Current Yield</p>
                  <p className="text-lg font-bold" data-id="element-783">4.8 tons/ha</p>
                  <p className="text-xs text-green-600" data-id="element-784">+12% vs target</p>
                </div>
                <div className="bg-gray-50 p-3 rounded-lg" data-id="element-785">
                  <p className="text-xs text-gray-500" data-id="element-786">Production Cost</p>
                  <p className="text-lg font-bold" data-id="element-787">RM 2,450/ha</p>
                  <p className="text-xs text-red-600" data-id="element-788">+5% vs budget</p>
                </div>
                <div className="bg-gray-50 p-3 rounded-lg" data-id="element-789">
                  <p className="text-xs text-gray-500" data-id="element-790">Efficiency</p>
                  <p className="text-lg font-bold" data-id="element-791">87%</p>
                  <p className="text-xs text-green-600" data-id="element-792">+3% vs last cycle</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Sidebar Content */}
        <div className="lg:col-span-1" data-id="element-793">
          {/* Weather */}
          <div className="bg-white rounded-lg shadow-sm p-4" data-id="element-794">
            <div className="flex justify-between items-center mb-4" data-id="element-795">
              <h2 className="text-lg font-semibold" data-id="element-796">Weather</h2>
              <p className="text-sm" data-id="element-797">Kedah, MY</p>
            </div>
            <div className="flex flex-col items-center p-4 bg-blue-50 rounded-lg" data-id="element-798">
              <CloudRain size={48} className="text-blue-500 mb-2" data-id="element-799" />
              <p className="text-2xl font-bold" data-id="element-800">26°C</p>
              <p className="text-sm" data-id="element-801">Light Rain</p>
              <div className="w-full grid grid-cols-3 gap-2 mt-4 text-center" data-id="element-802">
                <div data-id="element-803">
                  <p className="text-xs text-gray-500" data-id="element-804">Humidity</p>
                  <p className="font-medium" data-id="element-805">82%</p>
                </div>
                <div data-id="element-806">
                  <p className="text-xs text-gray-500" data-id="element-807">Wind</p>
                  <p className="font-medium" data-id="element-808">8 km/h</p>
                </div>
                <div data-id="element-809">
                  <p className="text-xs text-gray-500" data-id="element-810">Rainfall</p>
                  <p className="font-medium" data-id="element-811">4.2 mm</p>
                </div>
              </div>
            </div>
            <div className="mt-4" data-id="element-812">
              <p className="text-sm text-amber-600 flex items-center" data-id="element-813">
                <AlertCircle size={14} className="mr-1" data-id="element-814" />
                Heavy rain expected tomorrow
              </p>
            </div>
          </div>
          {/* Upcoming Tasks */}
          <div className="bg-white rounded-lg shadow-sm p-4 mt-6" data-id="element-815">
            <div className="flex justify-between items-center mb-4" data-id="element-816">
              <h2 className="text-lg font-semibold flex items-center" data-id="element-817">
                <CalendarIcon size={18} className="mr-2 text-amber-600" data-id="element-818" />
                Upcoming Tasks
              </h2>
              <button className="text-sm text-leaf-green hover:underline" data-id="element-819">
                View all
              </button>
            </div>
            <div className="space-y-3" data-id="element-820">
              {upcomingTasks.map(task => <div key={task.id} className="flex items-center p-3 border border-gray-200 rounded-lg hover:border-leaf-green transition-colors" data-id="element-821">
                  <div className="flex-1" data-id="element-822">
                    <p className="font-medium text-sm" data-id="element-823">{task.title}</p>
                    <p className="text-xs text-gray-600" data-id="element-824">{task.project}</p>
                  </div>
                  <div className="ml-4 text-right" data-id="element-825">
                    <p className="text-xs text-gray-600" data-id="element-826">
                      {new Date(task.dueDate).toLocaleDateString('en-MY', {
                    day: 'numeric',
                    month: 'short'
                  })}
                    </p>
                    <span className={`text-xs px-1.5 py-0.5 rounded mt-1 inline-block ${task.priority === 'High' ? 'bg-red-100 text-red-800' : 'bg-blue-100 text-blue-800'}`} data-id="element-827">
                      {task.priority}
                    </span>
                  </div>
                </div>)}
            </div>
            <button className="w-full mt-4 py-2 text-sm text-leaf-green border border-leaf-green rounded-md hover:bg-leaf-green/10" data-id="element-828">
              Add New Task
            </button>
          </div>
          {/* Investor Updates */}
          <div className="bg-white rounded-lg shadow-sm p-4 mt-6" data-id="element-829">
            <div className="flex justify-between items-center mb-4" data-id="element-830">
              <h2 className="text-lg font-semibold flex items-center" data-id="element-831">
                <LineChart size={18} className="mr-2 text-green-600" data-id="element-832" />
                Investor Updates
              </h2>
            </div>
            <div className="p-4 border border-dashed border-leaf-green rounded-lg bg-leaf-green/5" data-id="element-833">
              <p className="text-sm" data-id="element-834">
                Keep your investors informed about your project progress
              </p>
              <button className="w-full mt-3 py-2 text-sm text-white bg-leaf-green rounded-md hover:bg-leaf-green/90" data-id="element-835">
                Post Progress Update
              </button>
            </div>
            <div className="mt-4 text-sm text-gray-600" data-id="element-836">
              <p data-id="element-837">Last update: 5 days ago</p>
              <p className="mt-1" data-id="element-838">Next update due: 2 days</p>
            </div>
          </div>
        </div>
      </div>
    </UserLayout>;
};